import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTooltipComponent } from './custom_tool-tip.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [CommonModule, NgbModule],
  exports: [CustomTooltipComponent],
  declarations: [CustomTooltipComponent],
  providers: []
})
export class CustomToolTipModule {}
